//EC-495: My Account- Account Setting - Add margin from top

import { manageSubscriptionsStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsManageSubscriptions";
import { css } from "styled-components";

manageSubscriptionsStyles.manageSubscriptionsTitle = {
    variant: "h2",
    as: "h2",
    css: css`
        margin-top: 15px;
        margin-bottom: 4px; // decrease manage subscriptions bottom margin
    `,
};
